import PropTypes from 'prop-types';
import { StarIcon } from '@heroicons/react/solid';
import { TooltipText } from '@/components/common';
import STEP_RESULT_TYPE from './stepResultType';

const StepItem = ({ step, showDependentEntities }) => {
  const { label, tooltip, Icon, iconColor, textColor } = STEP_RESULT_TYPE.find(step.type);

  return (
    <div className="flex items-start gap-x-3 p-3 border border-gray-200 rounded-md bg-gray-50">
      <div className="flex-shrink-0">
        {tooltip ? (
          <TooltipText
            id={`steps-report-step-${step.order}`}
            text={<Icon className={`h-5 w-5 ${iconColor}`} aria-hidden="true" />}
            message={tooltip}
            className="max-w-sm"
          />
        ) : (
          <Icon className={`h-5 w-5 ${iconColor}`} aria-hidden="true" />
        )}
      </div>
      <div className="flex-grow">
        <div className={`text-sm font-medium ${textColor} flex items-center gap-x-1`}>
          Step {step.order}: {label}
          {step.is_mandatory && (
            <TooltipText
              id={`steps-report-step-${step.order}-mandatory`}
              text={<StarIcon className="h-3.5 w-3.5 text-amber-400 flex-shrink-0" aria-hidden="true" />}
              message="Mandatory step"
            />
          )}
        </div>
        <div
          className="text-sm text-gray-600 break-all mt-1"
          title={step.message || 'No message provided'}
        >
          {step.message || 'No message provided'}
        </div>
        {step.context && step.context.map((contextItem, index) => (
          <div
            key={index}
            className="text-sm text-gray-600 break-all mt-1"
            title={contextItem}
          >
            {contextItem}
          </div>
        ))}
        {showDependentEntities && step.dependent_entities && (
          <>
            <div className="text-xs text-gray-900 break-all mt-3">
              Dependent entities:
            </div>
            {step.dependent_entities.map((dependentEntity, index) => (
              <div
                key={index}
                className="text-xs text-gray-600 break-all mt-1"
                title={dependentEntity}
              >
                {dependentEntity}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

StepItem.propTypes = {
  step: PropTypes.shape({
    order: PropTypes.number.isRequired,
    is_successful: PropTypes.bool.isRequired,
    is_mandatory: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    context: PropTypes.arrayOf(PropTypes.string),
    dependent_entities: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  showDependentEntities: PropTypes.bool.isRequired,
};

export default StepItem;
